<script>
import common from './common.vue';

export default {
  mixins: [common],
  data() {
    return {
      zhanghaoIcon: `${this.$cdnLink}/wanXin/tg2/zhanghao.png`,
      mimaIcon: `${this.$cdnLink}/wanXin/tg2/mima.png`,
      xuanzhongIcon: `${this.$cdnLink}/wanXin/tg2/xuanzhong.png`,
      weixuanzhongIcon: `${this.$cdnLink}/wanXin/tg2/weixuanzhong.png`
    }
  }
};
</script>

<style lang="scss" module>
@import "../../../assets/css/tg2.scss";

.wrap {
  @include common-window(true);
  > main {
    padding-top: 0.2rem;
    .accountWrap {
      position: relative;
    }
    .inputWrap {
      @include common-inputWrap();
      justify-content: flex-start;
      padding-left: 0.25rem;
      .leftIcon {
        margin-right: 0.16rem;
      }
      &.pwd {
        margin-top: 0.2rem;
      }
    }
    .redirect {
      display: flex;
      color: $primary-color-1;
      justify-content: space-between;
      width: 4.44rem;
      margin: auto;
      font-size: $font-nm-1;
      > span {
        padding: 0.30rem 0.22rem 0.22rem 0.29rem;
        &:active {
          opacity: 0.8;
        }
      }
    }
    .submitBtn {
      @include common-button();
      margin-top: .14rem;
    }
    .agree {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.18rem;
      color: #999999;
      margin-top: 0.16rem;
      > img {
        width: 0.17rem;
        height: 0.17rem;
        margin-right: 0.1rem;
        margin-top: 0.02rem;
      }
    }
  }
  &.fullScreen {
    @include full-screen-window(true);
    > main {
      padding-top: 17px;
      .accountWrap {
        position: relative;
      }
      .inputWrap {
        @include full-screen-inputWrap();
        justify-content: flex-start;
        padding-left: 12px;
        .leftIcon {
          margin-right: 8px;
        }
        &.pwd {
          margin-top: 16px;
        }
      }
      .redirect {
        display: flex;
        color: $primary-color-1;
        justify-content: space-between;
        width: 222px;
        margin: auto;
        font-size: $font-nm;
        > span {
          padding: 15px 11px 11px 14px;
          &:active {
            opacity: 0.8;
          }
        }
      }
      .submitBtn {
        @include full-screen-button();
        margin-top: 7px;
      }
      .agree {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 10px;
        color: #999999;
        margin-top: 8px;
        > img {
          width: 8px;
          height: 8px;
          margin-right: 5px;
          margin-top: 1px;
        }
      }
    }
  }
}
</style>